import './ImageAssets.scss'

const ImageAssets = () => {
    return (
        <>
        <div className="logo-img">
            <img src="./images/logo.png" alt="logo" />
        </div>
        <div className="mobile-img">
            <img src="./images/mobile.png" alt="mobile" />
        </div>
        <div className="stores-img">
            <img src="./images/stores.png" alt="stores" />
        </div>
        </>
    )
}

export default ImageAssets;
